import React from 'react'

import CustomLink from 'components/Link/CustomLink'

import styles from './Sitemap.module.scss'

import Caret from 'assets/icons/icon-caretBlue.svg'

export type Breadcrumb = {
  text: string
  href: string
}

const SitemapBreadcrumbs: React.FC<{ breadcrumbs?: Breadcrumb[] }> = ({
  breadcrumbs = [],
}) => {
  if (!breadcrumbs) return null

  return (
    <nav aria-label="sitemap breadcrumbs" className={styles.breadcrumbs}>
      {breadcrumbs.map((breadcrumb, index) => {
        const isLastCrumb = index === breadcrumbs.length - 1

        return isLastCrumb ? (
          <p className={styles.lastCrumb} key={breadcrumb.href}>
            {breadcrumb.text}
          </p>
        ) : (
          <p key={breadcrumb.href}>
            <CustomLink aria-label={breadcrumb.text} href={breadcrumb.href}>
              {breadcrumb.text}
            </CustomLink>
            {!isLastCrumb && (
              <span className={styles.caret}>
                <Caret />
              </span>
            )}
          </p>
        )
      })}
    </nav>
  )
}

export default SitemapBreadcrumbs
